import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { googleAnalyticProductDetailsView } from 'actions/googleAnalytic'
import withType from 'components/common/hoc/withType'
import { getGTMData } from './helpers'
import BOTServiceDetails from './BOTServiceDetails'

const withSendAnalyticOnDidMount = lifecycle({
  componentDidMount() {
    const { googleAnalyticProductDetailsView, serviceDetails } = this.props

    googleAnalyticProductDetailsView({ data: getGTMData(serviceDetails) })
  }
})

export default compose(
  withType({ type: 'BOTServiceDetails' }),
  connect(null, { googleAnalyticProductDetailsView }),
  withSendAnalyticOnDidMount
)(BOTServiceDetails)
